export const AssignmentVisitSchedule = {
  SpecificTime: 'SpecificTime',
  SingleTimeSlot: 'SingleTimeSlot',
  MultipleTimeSlots: 'MultipleTimeSlots',
};
